module.exports = __webpack_public_path__ + "img/diners.4d7b56bb.png";